<span matDialogTitle>{{ 'Conferma operazione' | siaTranslate }}</span>
<button mat-icon-button matDialogClose (click)="onNoClick()">
  <mat-icon> close </mat-icon>
</button>
<mat-dialog-content>
  <div class="flex w-full justify-start">
    <span [innerHTML]="messageHtml()"></span>
  </div>
  <mat-form-field class="mt-4 w-full">
    <mat-label>{{ label() | siaTranslate }}</mat-label>
    <input
      matInput
      [type]="inputType()"
      [ngModel]="value()"
      (ngModelChange)="onValueChange($event)"
      (keydown.enter)="onEnterKey($event)"
      [autofocus]="true"
      required
    />
    @if (isPassword() && value().length > 0) {
      <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()">
        <mat-icon>{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    }
    @if (showValidationError()) {
      <mat-error>
        {{ errorMessage() | siaTranslate }}
      </mat-error>
    }
  </mat-form-field>
</mat-dialog-content>
<div matDialogActions align="end">
  <button mat-button (click)="onYesClick()" [disabled]="isValueInvalid()">
    {{ yesLabel() | siaTranslate }}
  </button>
  <button mat-button (click)="onNoClick()" class="error">
    {{ noLabel() | siaTranslate }}
  </button>
</div>
